import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

import { revertToRevision } from "editor/actions/revisions";

class Revert extends React.Component {
  constructor(props) {
    super(props);
    this.state = { revertCompleted: false };
  }

  componentDidMount() {
    return this.props
      .revertToRevision(
        this.props.match.params.id,
        this.props.match.params.revision,
        this.props.head_rev
      )
      .then(() => {
        this.setState({ revertCompleted: true });
      });
  }

  render() {
    if (!this.state.revertCompleted) {
      return null;
    } else {
      return (
        <Redirect
          to={`/editor/${this.props.match.params.type}/${this.props.match.params.id}`}
        />
      );
    }
  }
}

const mapStateToProps = state => ({
  head_rev: state.editor.form.head_rev,
});

const mapDispatchToProps = {
  revertToRevision,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Revert);

Revert.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      revision: PropTypes.string.isRequired,
    }),
  }),
  revertToRevision: PropTypes.func.isRequired,
  head_rev: PropTypes.string,
};
